<template>
    <div id="ComingSoon">
        <div class="coming-soon-image">
            <ComingSoonDataIcon style="width: 400px; height: 250px" />
        </div>
        <div class="coming-soon-text">
            <h3>{{ noDataText || $t("chatbotv2.noContentAdded") }}</h3>
            <p>{{ $t("chatbotv2.scarpOrAddContent") }}</p>
        </div>
        <div class="comming-soon-btn-container">
            <SupsisButton ghost @click="showHowItWorksModal = true">
                <span>{{ $t("chatbotv2.howItWorks") }}</span>
            </SupsisButton>
            <SupsisButton primary @click="() => addContent()" :disabled="disabled">
                <i class="material-icons">add</i>
                <span>{{ actionText || $t("chatbotv2.addContent") }}</span>
            </SupsisButton>
        </div>

        <!-- How It Works Modal -->
        <a-modal
            v-if="showHowItWorksModal"
            :visible="showHowItWorksModal"
            :footer="null"
            @cancel="showHowItWorksModal = false"
            class="how-it-works-modal"
            :width="600"
        >
            <div class="how-it-works-content">
                <div class="modal-icon">
                    <i class="material-icons">info_outline</i>
                </div>
                <h3 class="modal-title">{{ $t("chatbotv2.howItWorks") }}</h3>
                <div class="modal-description">
                    <p class="intro-text">
                        {{ $t('chatbotv2.comingSoonVectorIntro') }}
                    </p>
                    <div class="steps">
                        <div class="step">
                            <div class="step-number">1</div>
                            <div class="step-content">
                                <h4>{{ $t('chatbotv2.comingSoonStep1Title') }}</h4>
                                <p>{{ $t('chatbotv2.comingSoonStep1Desc') }}</p>
                            </div>
                        </div>
                        <div class="step">
                            <div class="step-number">2</div>
                            <div class="step-content">
                                <h4>{{ $t('chatbotv2.comingSoonStep2Title') }}</h4>
                                <p>{{ $t('chatbotv2.comingSoonStep2Desc') }}</p>
                            </div>
                        </div>
                        <div class="step">
                            <div class="step-number">3</div>
                            <div class="step-content">
                                <h4>{{ $t('chatbotv2.comingSoonStep3Title') }}</h4>
                                <p>{{ $t('chatbotv2.comingSoonStep3Desc') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="info-box">
                        <i class="material-icons">lightbulb_outline</i>
                        <span>{{ $t('chatbotv2.comingSoonTip') }}</span>
                    </div>
                </div>
                <div class="modal-actions">
                    <SupsisButton primary @click="showHowItWorksModal = false">
                        <span>{{ $t('chatbotv2.comingSoonGotIt') }}</span>
                    </SupsisButton>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import ComingSoonDataIcon from "../pages/integrations/svg/ComingSoonDataIcon.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default {
    name: "ComingSoonData",
    components: {
        ComingSoonDataIcon,
        SupsisButton,
    },
    props: {
        addContent: {
            type: Function,
            default: () => {},
        },
        actionText: {
            type: String,
        },
        noDataText: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showHowItWorksModal: false,
        };
    },
};
</script>
<style scoped lang="scss">
#ComingSoon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .coming-soon-image {
        width: 400px;
        height: 250px;
    }

    .coming-soon-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h3 {
            font-size: 24px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            line-height: 32px;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-default);
            line-height: 24px;
        }
    }

    .comming-soon-btn-container {
        display: flex;
        gap: 20px;
        justify-content: center;
        align-items: center;
    }
}

// Modal Styles
::v-deep .how-it-works-modal {
    .ant-modal-content {
        border-radius: 12px;
    }

    .ant-modal-body {
        padding: 32px;
    }

    .how-it-works-content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .modal-icon {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;

            i {
                font-size: 32px;
                color: white;
            }
        }

        .modal-title {
            font-size: 24px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            margin-bottom: 16px;
            text-align: center;
        }

        .modal-description {
            width: 100%;

            .intro-text {
                font-size: 16px;
                color: var(--color-text-default);
                text-align: center;
                margin-bottom: 24px;
                line-height: 1.6;
            }

            .steps {
                display: flex;
                flex-direction: column;
                gap: 20px;
                margin-bottom: 24px;

                .step {
                    display: flex;
                    gap: 16px;
                    align-items: flex-start;

                    .step-number {
                        min-width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        color: white;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 700;
                        font-size: 16px;
                    }

                    .step-content {
                        flex: 1;

                        h4 {
                            font-size: 16px;
                            font-weight: 600;
                            color: var(--color-text-strong-default);
                            margin-bottom: 4px;
                        }

                        p {
                            font-size: 14px;
                            color: var(--color-text-default);
                            line-height: 1.5;
                            margin: 0;
                        }
                    }
                }
            }

            .info-box {
                background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
                border-radius: 8px;
                padding: 16px;
                display: flex;
                gap: 12px;
                align-items: flex-start;

                i {
                    color: #667eea;
                    font-size: 20px;
                }

                span {
                    flex: 1;
                    font-size: 14px;
                    color: var(--color-text-default);
                    line-height: 1.5;
                }
            }
        }

        .modal-actions {
            margin-top: 24px;
            display: flex;
            justify-content: center;
        }
    }
}
</style>
